import ManageMenu from '../pages/manager/ManageMenu';
import ManageTable from '../pages/manager/ManageTable';
import Payments from '../pages/manager/Payments';
import Orders from '../pages/manager/Orders';
import Home from '../pages/manager/Home';
import AddUser from '../pages/manager/AddUser';
import Preferences from '../pages/manager/Preferences';
import Order from '../pages/manager/Order';
import AddCategory from '../pages/manager/AddCategory';
import ResetBill from '../pages/manager/ResetBill';
import SalesSummary from '../pages/manager/Reports/SalesSummary';
import SalesDetails from '../pages/manager/Reports/SalesDetails';
import Collection from '../pages/manager/Reports/Collection';
import ItemWiseDetails from '../pages/manager/Reports/ItemWiseDetails';

const ManagerRoutes = [
  { path: '/unit_manager/home', element: <Home />, exact: true },
  { path: '/unit_manager/options', element: <Preferences />, exact: true },
  { path: '/unit_manager/add-category', element: <AddCategory />, exact: true },
  { path: '/unit_manager/tables', element: <ManageTable />, exact: true },
  { path: '/unit_manager/menu', element: <ManageMenu />, exact: true },
  { path: '/unit_manager/order', element: <Order />, exact: true },
  { path: '/unit_manager/reset-bill', element: <ResetBill />, exact: true },
  { path: '/unit_manager/orders', element: <Orders />, exact: true },
  { path: '/unit_manager/payments', element: <Payments />, exact: true },
  { path: '/unit_manager/add-user', element: <AddUser />, exact: true },
  { path: '/unit_manager/reports/sales-summary', element: <SalesSummary />, exact: true },
  { path: '/unit_manager/reports/sales-details', element: <SalesDetails />, exact: true },
  { path: '/unit_manager/reports/item-wise-details', element: <ItemWiseDetails />, exact: true },
  { path: '/unit_manager/reports/collection', element: <Collection />, exact: true },
];

export default ManagerRoutes;